type Option<T extends string> = { value: T; label: React.ReactNode; disabled?: boolean; title?: string }

/** Neutral segmented switch (Sell / Buy, Core / Expert, Auto / Manual). */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  className = '',
}: {
  value: T
  onChange: (value: T) => void
  options: Option<T>[]
  className?: string
}) {
  return (
    <div className={`segmented ${className}`} role="radiogroup">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          disabled={option.disabled}
          title={option.title}
          aria-label={option.title}
          onClick={() => onChange(option.value)}
          className="segmented-option"
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
